import { usePushNotifications } from "@/hooks/usePushNotifications";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Button } from "../ui/button";
import { BellIcon, BellOffIcon } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import greenDot from "@/assets/green_circle.png";
import redDot from "@/assets/red_circle.png";

export default function PushNotificationSettings() {
  const {
    isSupported,
    permission,
    subscription,
    error,
    requestNotificationPermission,
    unsubscribeFromPush,
  } = usePushNotifications();
  const t = useTranslation();

  const handleDisableNotifications = () => {
    unsubscribeFromPush().catch((err) => {
      console.error("Failed to disable notifications:", err);
    });
  };

  const handleEnableNotifications = () => {
    requestNotificationPermission().catch((err) => {
      console.error("Failed to enable notifications:", err);
    });
  };

  if (!isSupported) {
    return;
  }

  return (
    <Card className="dark w-full max-w-lg">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">
          {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.TITLE}
        </CardTitle>
        <CardDescription>
          {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.DESCRIPTION}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {permission === "granted" ? (
          <>
            {subscription ? (
              <div className="flex flex-row items-center gap-x-4">
                <div className="text-sm flex flex-row items-center">
                  <img src={greenDot} className="w-4 h-4 mr-2" />
                  {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.ENABLED_STATUS}
                </div>
                <Button variant="outline" onClick={handleDisableNotifications}>
                  <BellOffIcon className="mr-2 h-5 w-5" />
                  {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.DISABLE_BUTTON}
                </Button>
              </div>
            ) : (
              <Button onClick={handleEnableNotifications}>
                <BellIcon className="mr-2 h-5 w-5" />
                {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.ENABLE_BUTTON}
              </Button>
            )}
          </>
        ) : permission === "denied" ? (
          <div className="text-sm flex flex-row items-center">
            <img src={redDot} className="w-4 h-4 mr-2" />
            {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.DISABLED_STATUS}
          </div>
        ) : (
          <Button onClick={handleEnableNotifications}>
            <BellIcon className="mr-2 h-5 w-5" />
            {t.PUSH_NOTIFICATIONS_SETTINGS.LABELS.ENABLE_BUTTON}
          </Button>
        )}
        {error && <div className="text-red-700 text-sm mt-2">{error}</div>}
      </CardContent>
    </Card>
  );
}
